import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services';
import { AUTH_ROUTES } from '../tokens';

export const guestGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const routes = inject(AUTH_ROUTES);

  const isAuthenticated = storage.getItem('isLoggedIn') === 'true';
  console.log('[guestGuard]', { isAuthenticated, homeUrl: routes.homeUrl });
  if (isAuthenticated) {
    console.log('[guestGuard] → redirect to home');
    router.navigateByUrl(routes.homeUrl, { replaceUrl: true });
    return false;
  }

  console.log('[guestGuard] → pass (guest allowed)');
  return true;
};
